import { apiClient } from './client';
import type { EventCategory, Severity, Vendor } from '@ixam/shared';

export interface RuleConditionsDto {
  serverIds: string[];
  vendors: Vendor[];
  severities: Severity[];
  categories: EventCategory[];
  tagsAny: string[];
}

export interface RuleActionsDto {
  channelIds: string[];
  suppressDuplicatesMinutes: number;
}

export interface RuleDto {
  _id: string;
  name: string;
  enabled: boolean;
  priority: number;
  conditions: RuleConditionsDto;
  actions: RuleActionsDto;
  stopProcessing: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateRuleInput {
  name: string;
  enabled?: boolean;
  priority?: number;
  conditions?: Partial<RuleConditionsDto>;
  actions: { channelIds: string[]; suppressDuplicatesMinutes?: number };
  stopProcessing?: boolean;
}

export type UpdateRuleInput = Partial<CreateRuleInput>;

export async function listRules(): Promise<RuleDto[]> {
  const res = await apiClient.get<{ items: RuleDto[] }>('/rules');
  return res.data.items;
}

export async function createRule(input: CreateRuleInput): Promise<RuleDto> {
  const res = await apiClient.post<{ rule: RuleDto }>('/rules', input);
  return res.data.rule;
}

export async function updateRule(id: string, input: UpdateRuleInput): Promise<RuleDto> {
  const res = await apiClient.put<{ rule: RuleDto }>(`/rules/${id}`, input);
  return res.data.rule;
}

export async function deleteRule(id: string): Promise<void> {
  await apiClient.delete(`/rules/${id}`);
}
